import { css, html } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { property } from "lit/decorators/property.js";
import { BsFormItem } from "../atoms/form-item";
import { continueWithAuthKindText } from "../util/translate-util";
import { AuthProviderKind, QUICK_COLORS, User } from "shared";
import { guid } from "../util/guid";
import { renderSmileyAvatar } from "../util/smiley-avatar";

const GUEST_AVATAR_SIZE = 24;

@customElement("bs-auth-button")
export class BsAuthButton extends BsFormItem {
	@property({ type: String, reflect: true }) kind: AuthProviderKind = "guest";
	@property({ type: Boolean, reflect: true }) invert = true;
	@property({ type: Boolean, reflect: true }) fill = true;
	@property({ type: Object }) user?: User;

	static get styles() {
		return [
			...super.styles,
			css`
				:host {
					position: relative;
					--form-item-justify-content: flex-start;
				}

				:host([kind="google"]) {
					--form-item-border-color: #1f87fc;
				}

				:host([kind="microsoft"]) {
					--form-item-border-color: #81bc06;
				}

				:host([kind="apple"]) {
					--form-item-border-color: #262626;
				}

				:host([kind="guest"]) {
					--form-item-border-color: #a3a3a3;
				}

				#content {
					display: flex;
					align-items: center;
					gap: var(--space-m);
				}

				#img {
					width: 24px;
					aspect-ratio: 1 / 1;
					object-fit: contain;
				}
			`
		];
	}

	renderAuthIcon() {
		switch (this.kind) {
			case "guest":
				return html`
					${renderSmileyAvatar({
						name: this.user?.id ?? guid(),
						size: GUEST_AVATAR_SIZE,
						square: false,
						primaryColor: this.user?.color,
						colors: QUICK_COLORS
					})}
				`;
			default:
				return html`<img
					id="img"
					alt="${this.kind} authentication illustration"
					src="/assets/auth/${this.kind}.svg"
				/>`;
		}
	}

	render() {
		return html`
			<button class="input">
				<div id="content">
					${this.renderAuthIcon()}
					<span>${continueWithAuthKindText(this.kind)}</span>
				</div>
			</button>
		`;
	}
}
